/* eslint-disable max-len */
import { toastr } from 'react-redux-toastr';
import {
    pendingTask, // The action key for modifying loading state
    begin, // The action value if a "long" running task begun
    end, // The action value if a "long" running task ended
} from 'react-redux-spinner';
// eslint-disable-next-line import/no-unresolved
import { correctBrowserTimezone, getDateTimeFormats, formatUTCDateAsIs } from '@commonClient2/services/ukgDateTime';
import { UPDATE_WORKPLAN_PUBLISH_PROGRESS } from './workplanPublishProgress.actions';
import { LOADING_START, LOADING_END } from '../../../store/loading';
import {
    GetWorkplanPublishProgress,
} from '../../services/api-endpoints';
import { parseWorkplanPublishProgressResponse } from './workplanPublishProgress.helper';

/**
 * @param {string} profileId
 */
export const openPublishProgressSidePanel = (profileId) =>/** @param {import('redux').Dispatch} dispatch  @param {() => ShiftBidding.ManagerStore} getState */async (dispatch, getState) => {
    dispatch({ type: LOADING_START, [pendingTask]: begin });
    try {
        const response = await GetWorkplanPublishProgress(profileId);
        const { bidProfileManagement, bidProfile } = getState();
        const parsedResponse = parseWorkplanPublishProgressResponse(response, bidProfileManagement, bidProfile);
        dispatch({
            type: UPDATE_WORKPLAN_PUBLISH_PROGRESS,
            payload: parsedResponse,
        });
    } catch (error) {
        toastr.error('Loading publish progress information', error.response.data.Message);
    } finally {
        dispatch({ type: LOADING_END, [pendingTask]: end });
    }
};
